
const Logo = ({ width = 400, height = 111 }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 400 111"
			width={width}
			height={height}
		>
			<path
				fill="#009fe3"
				d="M305.655 34.672h.196l7.766 24.578h-15.925ZM270.26 85.404h18.778l4.425-12.583h24.483l4.325 12.583h19.075l-26.254-70.198H296.51Zm67.448-23.595c.096 17.991 14.354 25.07 30.479 25.07 15.437 0 30.579-5.7 30.579-23.495 0-12.687-10.225-17.404-20.354-20.258-10.225-2.85-20.354-3.834-20.354-9.242 0-4.62 4.917-5.995 8.85-5.995 5.604 0 11.604 2.062 11.308 8.454h18.287c-.096-15.83-14.158-22.613-28.12-22.613-13.175 0-28.612 5.996-28.612 21.333 0 12.884 10.52 17.404 20.55 20.258 10.128 2.85 20.157 4.03 20.157 10.225 0 5.208-5.704 7.175-11.208 7.175-7.77 0-12.883-2.654-13.274-10.912Z"
			/>
			<path
				fill="#9d9d9c"
				d="M.96 85.406h17.208v-53.29h.196l14.746 53.29h13.962l14.75-53.29h.195v53.29h17.208V15.203h-26.94L40.192 62.007h-.2L27.9 15.203H.961Zm90.948 0h18.288V15.203H91.908Zm49.258-30.774h14.65c5.508 0 9.833 2.062 9.833 8.258 0 5.8-4.034 7.867-9.833 7.867h-14.65Zm-18.287 30.774h33.724c15.041 0 27.333-5.112 27.333-21.829 0-7.962-4.62-14.453-12.096-16.616 5.509-2.75 9.246-7.866 9.246-14.158 0-14.65-13.275-17.795-25.37-17.6h-32.837Zm18.287-56.044h14.158c3.833 0 7.47 1.67 7.47 6.787 0 5.012-4.324 6.683-7.47 6.683h-14.158Z"
			/>
			<path
				fill="#009fe3"
				d="M244.832 71.879h24.279c-2.955 7.754-10.413 16.003-21.788 16.824-18.82 1.359-26.207-13.837-25.828-23.941.837-22.237 24.487-38.216 24.487-38.216s12.933 10.296 20.029 23.058C259.394 27.246 244.68 2.73 244.68 2.73s-77.306 38.253-48.523 88.894c9.233 16.246 29.874 22.225 47.457 15.737 11.737-4.337 24.35-16.108 25.508-35.482h10.867V59.345h-35.158Z"
			/>
		</svg>
	)
}

export default Logo
